import * as React from 'react';

import values from 'lodash/values';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'js/l... Remove this comment to see the full error message
import provideFluxibleAppContext from 'js/lib/provideFluxibleAppContext';
import Retracked from 'js/lib/retracked';
import user from 'js/lib/user';

import ItemFeedbackContent from 'bundles/content-feedback/components/cds/item-feedback/ItemFeedbackContent';
import ItemTypes from 'bundles/content-feedback/constants/ItemTypes';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';
import itemFeedbackApp from 'bundles/content-feedback/itemFeedbackApp';
import { getItemFeedbackEventContext } from 'bundles/content-feedback/utils/ItemFeedbackUtils';
import type { ComputedItemType } from 'bundles/learner-progress/lib/ComputedItem';
import type { Item } from 'bundles/learner-progress/types/Item';

type InputProps = {
  courseId?: string;
  computedItem: Item | ComputedItemType;
  itemFeedbackType: ItemType;
  hideReportAnIssue?: boolean;
  className?: string;
  setIsUserReportingIssue?: (isUserReportingIssue: boolean) => void;
};

type PropsToComponent = InputProps & {
  courseId: string;
  // TODO tighten
  // NOTE tooltipPlacement is actually an optional type for the caller
  // there is a default prop
  tooltipPlacement: string;
  subItemId?: string;
  className?: string;
};

class ItemFeedback extends React.Component<PropsToComponent> {
  static contextTypes = {
    track: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof ItemFeedback.contextTypes>;

  static defaultProps = {
    tooltipPlacement: 'bottom',
  };

  render() {
    const {
      computedItem,
      itemFeedbackType,
      courseId,
      subItemId,
      tooltipPlacement,
      className,
      hideReportAnIssue,
      setIsUserReportingIssue,
    } = this.props;
    const { id: itemId } = computedItem;

    const isInvalidItemType = values(ItemTypes).indexOf(itemFeedbackType) === -1;

    if (!user.isAuthenticatedUser() || isInvalidItemType) {
      return null;
    }

    return (
      <div className={`rc-ItemFeedback ${className}`}>
        <ItemFeedbackContent
          key={itemId}
          computedItem={computedItem}
          itemFeedbackType={itemFeedbackType}
          courseId={courseId}
          subItemId={subItemId}
          hideReportAnIssue={hideReportAnIssue}
          tooltipPlacement={tooltipPlacement}
          setIsUserReportingIssue={setIsUserReportingIssue}
        />
      </div>
    );
  }
}

class TrackedItemFeedback extends React.Component<PropsToComponent> {
  static childContextTypes = {
    track: PropTypes.func,
  };

  getChildContext() {
    const { courseId, computedItem } = this.props;
    const { id: itemId } = computedItem;

    return {
      // NOTE: This is a legacy usage of `makeTracker` API to support its child being rendered inside a Backbone view.
      // Please do not copy this usage going forwards.
      track: Retracked.makeTracker(getItemFeedbackEventContext(itemId, courseId)),
    };
  }

  render() {
    const {
      courseId,
      computedItem,
      itemFeedbackType,
      subItemId,
      tooltipPlacement,
      className,
      hideReportAnIssue,
      setIsUserReportingIssue,
    } = this.props;

    return (
      <ItemFeedback
        setIsUserReportingIssue={setIsUserReportingIssue}
        computedItem={computedItem}
        itemFeedbackType={itemFeedbackType}
        courseId={courseId}
        subItemId={subItemId}
        tooltipPlacement={tooltipPlacement}
        className={className}
        hideReportAnIssue={hideReportAnIssue}
      />
    );
  }
}

const FluxibleItemFeedback = compose<PropsToComponent, InputProps>(
  provideFluxibleAppContext(itemFeedbackApp),
  // NOTE: this is only here because quiz views still use Backbone code
  connectToStores<PropsToComponent, Omit<PropsToComponent, 'courseId'>>(['CourseStore'], ({ CourseStore }) => ({
    courseId: CourseStore.getCourseId(),
  }))
)(TrackedItemFeedback);

export default FluxibleItemFeedback;
export const BaseComp = ItemFeedback;
